import { Button } from "Components/ui/button";
import { Separator } from "Components/ui/separator";
import { format } from "date-fns";
import jsPDF from "jspdf";
import { Download } from "lucide-react";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import succesCertificate from "../../../Assets/Images/succesCertificate.png";
import { getSingleCertificate } from "../../../Redux/Certificates/CertificatesActions";
import CertificateCard from "./CertificateCard";
import { Skeleton } from "Components/ui/skeleton";
import NotFound from "Pages/NotFound/NotFound";

function SingleCertificate({ withoutLogin }) {
  const [searchParams, setSearchParams] = useSearchParams();
  const [image, setImage] = useState(null);
  const navigate = useNavigate();

  // Utility function to detect Safari browser
  const isSafari = () => {
    const ua = navigator.userAgent.toLowerCase();
    return ua.includes("safari") && !ua.includes("chrome");
  };

  useEffect(() => {
    if (isSafari()) {
      setTimeout(() => {
        dispatch(getSingleCertificate(id));
      }, 1000);
    }
  }, []);

  const handleDownloadPDF = () => {
    const doc = new jsPDF({
      orientation: "portrait",
      unit: "px",
      format: [400, 400], // Ensures no white space
    });
    doc.addImage(image, "PNG", 0, 0, 400, 400);
    doc.save("certificate.pdf");
  };
  const {
    getSingleCertificateLoading,
    getSingleCertificateSuccess,
    getSingleCertificateError,
    singleCertificate,
  } = useSelector((state) => state.CertificatesReducer);
  const { id } = useParams();
  const dispatch = useDispatch();
  useEffect(() => {
    if (id) {
      dispatch(getSingleCertificate(id));
    }
  }, [id]);

  return (
    <div
      className={`relative flex flex-col gap-10 w-full ${
        withoutLogin && "p-8"
      }`}
    >
      <div className="w-full rounded-lg sm:p-6 p-0 flex flex-col gap-8 relative justify-center items-center mt-8">
        {getSingleCertificateLoading ? (
          <Skeleton className="xl:w-[50%] md:w-[60%] w-full  h-auto aspect-square rounded-lg" />
        ) : singleCertificate?.id ? (
          <>
            {" "}
            <div className="xl:w-[50%] md:w-[60%] w-full relative">
              <div
                className="flex flex-row sm:gap-4 gap-1 items-center absolute md:top-1  top-[-5px] translate-y-[-50%] 
            translate-x-[-50%]
            left-[50%]
            w-fit whitespace-nowrap bg-background text-base pr-6 pl-2 md:py-0 py-2 rounded-lg text-primary font-G_Bold"
                style={{
                  boxShadow: "0px 0px 40px 0px rgba(33,151,237,0.25)",
                }}
              >
                <img
                  src={succesCertificate}
                  alt="success"
                  className="md:w-[3rem] sm:w-[2rem] w-[1rem] -mr-1"
                />{" "}
                Certificate is Verified
              </div>
              {singleCertificate?.Certificate?.name && (
                <CertificateCard
                  certificateName={
                    singleCertificate?.Certificate?.type == "MILESTONE"
                      ? singleCertificate?.Certificate?.name
                          ?.split(" ")[0]
                          ?.toLowerCase()
                      : singleCertificate?.Certificate?.name ==
                        "Certificate Of Capital Allocation"
                      ? "capital"
                      : "withdraw"
                  }
                  setImageSingle={setImage}
                  userName={
                    singleCertificate?.name
                      ? singleCertificate?.name
                      : singleCertificate?.User?.firstName +
                        " " +
                        singleCertificate?.User?.lastName
                  }
                  date={
                    singleCertificate?.issueDate &&
                    format(new Date(singleCertificate?.issueDate), "yyyy-MM-dd")
                  }
                  amount={
                    singleCertificate?.amount
                      ? Number(singleCertificate?.amount).toLocaleString(
                          "en-US",
                          {
                            style: "currency",
                            currency: "USD",
                            minimumFractionDigits: 0,
                            maximumFractionDigits: 2,
                          }
                        )
                      : singleCertificate?.balance
                      ? Number(singleCertificate?.balance).toLocaleString(
                          "en-US",
                          {
                            style: "currency",
                            currency: "USD",
                            minimumFractionDigits: 0,
                            maximumFractionDigits: 2,
                          }
                        )
                      : "0.00"
                  }
                  stage={singleCertificate.challengeName}
                  link={
                    process.env.REACT_APP_LOCAL_API +
                    "/certificate/" +
                    singleCertificate?.id
                  }
                  onlyImage={true}
                  found={singleCertificate?.id}
                />
              )}
            </div>
            <div className="xl:w-[50%] md:w-[60%]   w-full ">
              <div className="bg-background p-4 rounded-lg w-full">
                <div className="flex flex-row justify-between items-center text-base">
                  <div className="opacity-[0.3]">Issued To</div>
                  <div>
                    {singleCertificate?.name
                      ? singleCertificate?.name
                      : singleCertificate?.User?.firstName +
                        " " +
                        singleCertificate?.User?.lastName}
                  </div>
                </div>
                <Separator className="bg-borderChallenge opacity-[0.14] my-4" />
                <div className="flex flex-row justify-between items-center text-base">
                  <div className="opacity-[0.3]">Date</div>
                  <div>
                    {singleCertificate?.issueDate &&
                      format(
                        new Date(singleCertificate?.issueDate),
                        "yyyy-MM-dd"
                      )}
                  </div>
                </div>
                <Separator className="bg-borderChallenge opacity-[0.14] my-4" />
                <div className="flex flex-row justify-between items-center text-base ">
                  <div className="opacity-[0.3]">Certificate Name</div>
                  <div>{singleCertificate?.Certificate?.name}</div>
                </div>
              </div>
              {searchParams?.get("user") == "admin" && (
                <div className="w-full px-2 mt-6 flex sm:flex-row flex-col items-center gap-4">
                  <Button
                    variant="outline"
                    className={`flex-1  w-full sm:py-6 py-2`}
                    disabled={!singleCertificate?.id}
                    onClick={() => {
                      singleCertificate?.id && handleDownloadPDF();
                    }}
                  >
                    <Download />
                    Download PDF
                  </Button>
                  <Button
                    variant="outline"
                    className={`flex-1  w-full sm:py-6 py-2`}
                    disabled={!singleCertificate?.id}
                    onClick={() => {
                      if (singleCertificate?.id) {
                        const a = document.createElement("a");
                        a.href = image;
                        a.download = "certificate.png";
                        a.click();
                      }
                    }}
                  >
                    <Download />
                    Download Image
                  </Button>
                </div>
              )}
            </div>
          </>
        ) : (
          !getSingleCertificateLoading && <NotFound />
        )}
      </div>
    </div>
  );
}

export default SingleCertificate;
